import { useState } from 'react'

import { UseTfaToken } from '@src/hooks/use-tfa-token/type'

export const useTfaToken = (): UseTfaToken => {
  const [tfaToken, setTfaToken] = useState<string | null>(null)
  const [tfaTokenExpiresAt, setTfaTokenExpiresAt] = useState<number | null>(
    null
  )
  return {
    tfaToken,
    setTfaToken,
    tfaTokenExpiresAt,
    setTfaTokenExpiresAt,
  }
}
